<template>
    <div class="chart" :style="{ height: height }" /> 
</template>

<script>
//import { echarts } from "echarts";
import * as echarts from 'echarts';
require("echarts/theme/shine"); // echarts theme
const consumptionsData = require("../../maps/data/eflex_consumption_demo_data.json");
export default {
  props: [
    "meter",
    "current",
    "vectors",
    "contract",
    "projectedConsumption",
    "start",
  ],
  data() {
    return {
      chart: null,
      sidebarElm: null,
      height: "350px",
      autoResize: true,
      meters: this.$props.meter,
      months: {
        1: "Jan",
        2: "Feb",
        3: "Mar",
        4: "Apr",
        5: "May",
        6: "Jun",
        7: "Jul",
        8: "Aug",
        9: "Sep",
        10: "Oct",
        11: "Nov",
        12: "Dec",
      },
      consumptions: [],
    };
  },
  mounted() {
    this.initChart("01/11/2020");
    if (this.autoResize) {
      this.__resizeHandler = this.debounce(() => {
        if (this.chart) {
          this.chart.resize();
        }
      }, 100);
      window.addEventListener("resize", this.__resizeHandler);
    }
    this.$nextTick(function () {
        this.getConsumptions("01/11/2020");
        // Code that will run only after the entire view has been rendered
    });
    this.$root.$on("getConsumptions", (date) => {
      console.log("HERE... test call method getConsumptions of ConsumptionsChart with date: "+date);
      return this.initChart(date);
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener("resize", this.__resizeHandler);
    }
    this.sidebarElm &&
      this.sidebarElm.removeEventListener(
        "transitionend",
        this.sidebarResizeHandler
      );
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    sidebarResizeHandler(e) {
      if (e.propertyName === "width") {
        this.__resizeHandler();
      }
    },
    setOptions() {
      this.chart.setOption({
        xAxis: {
          name: "hour",
          type: "category",
          data: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", 
                 "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"],
        },
        yAxis: {
          name: "kWh",
          type: "value",
        },
        title: {
          left: "center",
          text: "Energy Consumption",
        },
        series: [
          {
            //data: [820, 932, 901, 934, 1290, 1330, 1320],
            data: this.consumptions,
            type: "line",
          },
        ],
      });
    },
    initChart(date) {
        
        this.getConsumptions(date);
        //console.log("HERE... load consumptions sucessfull: " + this.consumptions.toString());
        this.chart = echarts.init(this.$el, "shine");
        this.setOptions();
    },
    debounce(func, wait, immediate) {
      let timeout, args, context, timestamp, result;
      const later = function () {
        // According to the last trigger interval
        const last = new Date().getTime() - timestamp;
        // The last time the wrapped function was called, the interval is last less than the set time interval wait
        if (last < wait && last > 0) {
          timeout = setTimeout(later, wait - last);
        } else {
          timeout = null;
          // If it is set to immediate===true, since the start boundary has already been called, there is no need to call it here.
          if (!immediate) {
            result = func.apply(context, args);
            if (!timeout) {
              context = args = null;
            }
          }
        }
      };
      return function (...args) {
        context = this;
        timestamp = new Date().getTime();
        const callNow = immediate && !timeout;
        // If the delay does not exist, reset the delay
        if (!timeout) {
          timeout = setTimeout(later, wait);
        }
        if (callNow) {
          result = func.apply(context, args);
          context = args = null;
        }
        return result;
      };
    },
    getConsumptions(date) {
        //console.log("HERE... consumptions data: " + consumptionsData.toString());
        this.consumptions = [];
      
        for (var i = 0; i < consumptionsData.length; i++) {
            if (consumptionsData[i].date == date) {
              this.consumptions.push(consumptionsData[i].consumption);
            }
        }
    
        console.log("HERE... consumptions: " + this.consumptions.toString());
    },
  },
updated() {
    // Fired every second, should always be true
    this.consumptions;
    console.log("HERE... updated consumptions: " + this.consumptions.toString());
  },
};
</script>